/*
 * Copyright (c) 2022. Revo Digital
 * ---
 * Author: gabrielecavallo
 * File: projectdata-slice.ts
 * Project: mle-client-n
 * Committed last: 2022/11/22 @ 1723
 * ---
 * Description:
 */

import {createSlice, PayloadAction} from "@reduxjs/toolkit";
import {ProjectDataFormValues} from "../../components/forms/ProjectDataForm";
import {ColorModes, MeasureUnits} from "../../common/enums";

export interface ProjectCreationState {
    actualValues: ProjectDataFormValues,
    cachedValues?: ProjectDataFormValues,
}

const _projectDataSlice = createSlice({
    name: 'project-data',
    initialState: {
        actualValues: {
            width: 0,
            height: 0,
            title: '',
            measureUnit: MeasureUnits.MM,
            colorProfile: ColorModes.COLORE
        },
        cachedValues: undefined,
    } as ProjectCreationState,
    reducers: {
        setWidth(state, payload: PayloadAction<number>) {
            state.actualValues.width = payload.payload;
        },
        setHeight(state, payload: PayloadAction<number>) {
            state.actualValues.height = payload.payload;
        },
        setTitle(state, payload: PayloadAction<string>) {
            state.actualValues.title = payload.payload;
        },
        setMeasureUnit(state, payload: PayloadAction<MeasureUnits>) {
            state.actualValues.measureUnit = payload.payload;
        },
        setProjectDataValues(state, payload: PayloadAction<ProjectDataFormValues>) {
            state.actualValues = payload.payload;
        },
        saveCache(state) {
            state.cachedValues = state.actualValues;
        },
        resetCache(state) {
            state.cachedValues = undefined;
        },
        resetActualValues(state) {
            state.actualValues = {
                width: 0,
                height: 0,
                title: '',
                measureUnit: MeasureUnits.MM,
                colorProfile: ColorModes.COLORE
            }
        }
    }
});

export const {
    setWidth,
    setHeight, setTitle, setMeasureUnit, setProjectDataValues, saveCache, resetCache, resetActualValues
} = _projectDataSlice.actions;
export const projectDataSlice = _projectDataSlice.reducer;